const menuButton = document.querySelector('.mobile-menu-trigger');
const mobileMenu = document.querySelector('#MobileMenu');

if (menuButton && mobileMenu) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
}

document.querySelectorAll('[data-product-filter]').forEach((button) => {
  button.addEventListener('click', () => {
    const filter = button.dataset.productFilter;
    document.querySelectorAll('[data-product-filter]').forEach((item) => item.classList.remove('active'));
    button.classList.add('active');
    document.querySelectorAll('[data-product-grid] .product-card').forEach((card) => {
      card.hidden = filter !== 'all' && card.dataset.productType !== filter;
    });
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const original = button.innerHTML;
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          items: [{
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number(form.querySelector('[name="quantity"]')?.value || 1)
          }]
        })
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      button.textContent = 'ĮDĖTA ✓';
    } catch {
      form.submit();
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.innerHTML = original;
      }, 1600);
    }
  });
});
